module.exports = __webpack_public_path__ + "img/d8.533406ef.jpg";